import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

declare global {
  interface Window {
    dataLayer: any;
  }
}

const pageview = (url) => {
  window?.dataLayer?.push({
    event: 'pageview',
    page: url,
  });
};
// this implementation is taken from nextjs example repo:
// https://github.com/vercel/next.js/tree/master/examples/with-google-tag-manager
export const GoogleTagProvider = ({ children }) => {
  const router = useRouter();
  const [isFirstPageLoad, setIsFirstPageLoad] = useState(true);

  useEffect(() => {
    if (isFirstPageLoad) {
      pageview(router?.asPath);
      setIsFirstPageLoad(false);
    }
    router.events.on('routeChangeComplete', pageview);
    return () => {
      router.events.off('routeChangeComplete', pageview);
    };
  }, [router.events]);

  return children;
};
